import { useCallback } from 'react';
import { useToast } from '@/ui';
import { isFileValid, OVERSIZED_FILE_MESSAGE } from '@/utils/file';

/**
 * Returns a guard for user file uploads. It returns `true` when the file is
 * within the shared size limit, and otherwise shows a friendly toast and
 * returns `false` so the caller can skip the upload. Use it at every point a
 * user can select a file so oversized uploads are rejected up front with a
 * warning instead of failing opaquely server-side.
 */
export const useFileSizeGuard = () => {
  const { purple } = useToast();

  return useCallback(
    (file: File): boolean => {
      if (isFileValid(file)) {
        return true;
      }

      purple(OVERSIZED_FILE_MESSAGE);
      return false;
    },
    [purple]
  );
};
